/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert_message_container[_ngcontent-%COMP%]{position:fixed;top:1px;left:0;display:flex;align-items:center;flex-direction:row;justify-content:center;width:100%;z-index:99}@media (min-width:1200px){.sidebar-backdrop[_ngcontent-%COMP%]{display:none}}@media (max-width:1199.98px){.sidebar-backdrop[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;left:0;top:0;z-index:18;cursor:pointer}}"];
export { styles as styles };
